<template>
  <div>
  <div class="page flex-col" v-if="$route.path == '/en'">
    <div class="group1 flex-col">
      <div class="main1 flex-col">
        <div class="box8 flex-col">
          <div class="main2 flex-row">
            <img
              class="img1"
              referrerpolicy="no-referrer"
              src="http://dftk-hw-cdn-ali.yingxiong.com/web/h_tank/assets/PC-e-slices/logo.png"
            />
            <img
              class="label1"
              referrerpolicy="no-referrer"
              src="http://dftk-hw-cdn-ali.yingxiong.com/web/h_tank/assets/PC-c-slices/slices/scanning.png"
            />
            <span
              class="s-load"
              @mouseenter="enter_code"
              @mouseleave="leave_code"
              >QR Code</span
            >
            <i class="lanel-i"></i>
            <img
              class="label1-2"
              referrerpolicy="no-referrer"
              src="http://dftk-hw-cdn-ali.yingxiong.com/web/h_tank/assets/PC-c-slices/slices/earth.png"
            />
            <div class="infoBox1" @click.stop="select_lan">
              <input
                type="text"
                v-model="selection"
                readonly="readonly"
                class="select-box"
              />
              <img
                class="icon1"
                referrerpolicy="no-referrer"
                src="http://dftk-hw-cdn-ali.yingxiong.com/web/h_tank/assets/PC-c-slices/slices/Inverted-triangle.png"
              />
              <div v-if="drop_down">
                <div
                  class="option"
                  v-for="(item, index) in lan"
                  :key="index"
                  @click="query_value($event)"
                >
                  {{ item }}
                </div>
              </div>
            </div>
            <i class="lanel-i" style="margin-left: 0.55rem"></i>
            <img
              style="margin-left: 0.33rem"
              class="label1-2-3"
              @click="facebook"
              referrerpolicy="no-referrer"
              src="http://dftk-hw-cdn-ali.yingxiong.com/web/h_tank/assets/PC-e-slices/Facebook.png"
            />
            <img
              class="label1-2-3"
              @click="youtube"
              referrerpolicy="no-referrer"
              src="http://dftk-hw-cdn-ali.yingxiong.com/web/h_tank/assets/PC-e-slices/YouTube.png"
            />
            <img
              class="label1-2-3"
              @click="instagram"
              referrerpolicy="no-referrer"
              src="http://dftk-hw-cdn-ali.yingxiong.com/web/h_tank/assets/PC-e-slices/Instagram.png"
            />
            <img
              v-show="is_code"
              class="label1-2-4"
              referrerpolicy="no-referrer"
              src="http://dftk-hw-cdn-ali.yingxiong.com/web/h_tank/assets/PC-c-slices/slices/e-code.png"
            />
          </div>
          <div class="bd2 flex-row">
            <img
              class="img3"
              referrerpolicy="no-referrer"
              src="http://dftk-hw-cdn-ali.yingxiong.com/web/h_tank/assets/PC-c-slices/slices/en.png"
            />
          </div>
          <div v-if="close" style="width:12rem;position: fixed;top: 50%;left: 50%;transform: translate(-50%, -50%);z-index: 9999;">
            <img  @click="c_close" src="http://dftk-hw-cdn-ali.yingxiong.com/web/h_tank/assets/c.png" alt="" 
              style="position: absolute;right: -.28rem;top: .2rem;cursor: pointer;height: 0.3rem;width:.3rem">
            <video  autoplay="autoplay"  muted  style="width:100%;height:7.5rem" controls>              
              <source :src="src_video" type="video/mp4">
              <source src="movie.ogg" type="video/ogg">
              <source src="movie.webm" type="video/webm">
              <object :data="src_video">
                <embed src="movie.swf">
              </object> 
            </video>
          </div> 
            <!-- 自动播放视频 -->
          <div v-show="is_loop" style="position: absolute;top: -8px;width:100%;height:100%;overflow: hidden;">
            <video muted loop autoplay="autoplay"  style="width:calc(100% + 1px);height:101%">              
              <source src="http://dftk-hw-cdn-ali.yingxiong.com/web/h_tank/assets/head_e.mp4" type="video/mp4">
              <source src="movie.ogg" type="video/ogg">
              <source src="movie.webm" type="video/webm">
              <object data="http://dftk-hw-cdn-ali.yingxiong.com/web/h_tank/assets/head_e.mp4">
                <embed src="movie.swf">
              </object> 
            </video>
          </div>
          <div  class="img2-box" @click="open">
             <img src="http://dftk-hw-cdn-ali.yingxiong.com/web/h_tank/assets/play.png" alt="">
          </div>
          <div class="pc-down-box-en">
            <!-- <img
              class="pc-down-img-en"
              referrerpolicy="no-referrer"
              src="http://dftk-hw-cdn-ali.yingxiong.com/web/h_tank/assets/PC-c-slices/slices/pc_down_en.png"
              @click="pcDown"
            /> -->
          </div>
          <div class="img3-box">
            <img
              class="img3-1"
              referrerpolicy="no-referrer"
              src="http://dftk-hw-cdn-ali.yingxiong.com/web/h_tank/assets/PC-c-slices/slices/google-en.png"
              @click="google"
            />
            <img
              class="img3-1"
              referrerpolicy="no-referrer"
              src="http://dftk-hw-cdn-ali.yingxiong.com/web/h_tank/assets/PC-c-slices/slices/apple-en.png"
              @click="phone"
            />
            <img
              class="img3-1"
              referrerpolicy="no-referrer"
              src="http://dftk-hw-cdn-ali.yingxiong.com/web/h_tank/assets/PC-c-slices/slices/recharge-en.png"
              @click="recharge"
            />
          </div>
        </div>
        <!-- 试听中心 -->
        <div class="box_1 flex-col">
          <img class="audition" src="http://dftk-hw-cdn-ali.yingxiong.com/web/h_tank/assets/en_Audition.png" alt="试听中心">
        </div>
        <div class="box_1_1 flex-col">
          <div class="audition_d" v-for="(item,index) in video_data" :key="index" @mouseenter="input_in(index)" @mouseleave="input_out(index)">
            <img class="audition_ph" :src="item.src" alt="试听中心">
              <img src="http://dftk-hw-cdn-ali.yingxiong.com/web/h_tank/assets/video_play.png" alt="" class="video_play" @click="play_video(item.id)" v-if="video_data[index].is_show">
            <div>
              <span class="audition_ph_m" :title="item.text">{{item.text}}</span>
              <span class="audition_ph_t">{{item.time}}</span>
            </div>
          </div>
        </div>
        <!-- 资讯 -->
        <div class="box9 flex-col">
          <div class="box1 flex-row">
            <span
              :class="{ word1_1: word1, 'word1-1_1': word1_1 }"
              @click="new_active"
              >EVENT</span
            >
            <div class="group4 flex-col"></div>
            <span :class="{ 'word-2_2': word2, 'info1-2_2': word2_2 }"
              >&nbsp;LATEST NEWS</span
            >
            <div class="group5 flex-col"></div>
          </div>
          <div class="box2 flex-row justify-between">
            <div class="mod1 flex-col justify-between" v-show="active">
              <img
                class="pic0"
                referrerpolicy="no-referrer"
                src="http://dftk-hw-cdn-ali.yingxiong.com/web/h_tank/assets/PC-c-slices/division.png"
              />
              <div class="box3 flex-row justify-between">
                <div class="outer1 flex-col">
                  <swiper :options="swiperOption" ref="mySwiper" id="outer">
                    <swiper-slide
                      ><img
                        @mouseenter="on_bot_enter"
                        @mouseleave="on_bot_leave"
                        style="width: 4.88rem; height: 4.88rem"
                        referrerpolicy="no-referrer"
                        src="http://dftk-hw-cdn-ali.yingxiong.com/web/h_tank/assets/PC-c-slices/activity.jpg"
                    /></swiper-slide>
                    <swiper-slide
                      ><img
                        @mouseenter="on_bot_enter"
                        @mouseleave="on_bot_leave"
                        style="width: 4.88rem; height: 4.88rem"
                        referrerpolicy="no-referrer"
                        src="http://dftk-hw-cdn-ali.yingxiong.com/web/h_tank/assets/Tiger-HAP-e-1.jpg"
                    /></swiper-slide>

                    <div class="swiper-pagination" slot="pagination">
                      <img
                        class="icon2"
                        referrerpolicy="no-referrer"
                        src="http://dftk-hw-cdn-ali.yingxiong.com/web/h_tank/assets/PC-c-slices/White-dot.png"
                      />
                    </div>
                  </swiper>
                </div>
                <div class="outer3 flex-col">
                  <span class="word2">05-30&nbsp;2022</span>
                  <span class="word3">LATEST NEWS</span>
                  <span class="infoBox2"
                    >99-Hero Strike
                    <br />
                    <br />During the event, you can claim the powerful 99-Hero
                    and abundant rewards by consuming specific amount of golds!

                    <br />M1A1 Abrams is coming!
                    <br />
                    <br />During the event, you can claim M1A1 Abrams when your
                    accumulated top-up reaches the corresponding amount (Special
                    Offers are excluded from Total Top Up).
                    <br />
                    <br />Lucky Easter Event
                    <br />
                    <br />During the event period, you have a chance to acquire
                    "Easter Bunny" and "Easter Egg" by participating in battles.
                    While Easter Bunnies can be used to redeem premium rewards
                    in Easter Redemption Event, you can directly obtain a
                    variety of materials by opening Easter Eggs.
                    <br />
                    <br />Vehicle Modification is Live
                    <br />
                    <br />During the event, CSH-2 Rooivalk, BMP-3, Challenger I
                    can be modified. You can claim rewards by completing the
                    corresponding tasks.
                  </span>
                </div>
              </div>
            </div>
            <div class="mod1 flex-col justify-between" v-show="nice">
              <img
                class="pic1-1"
                referrerpolicy="no-referrer"
                src="http://dftk-hw-cdn-ali.yingxiong.com/web/h_tank/assets/PC-c-slices/division.png"
              />
              <div class="box3 flex-row justify-between">
                <div class="outer1 flex-col">
                  <swiper :options="swiperOption1" ref="mySwiper1" id="outer">
                    <swiper-slide
                      ><img
                        @mouseenter="on_bot_enter"
                        @mouseleave="on_bot_leave"
                        style="width: 4.88rem; height: 4.88rem"
                        referrerpolicy="no-referrer"
                        src="https://t7.baidu.com/it/u=1595072465,3644073269&fm=193&f=GIF"
                    /></swiper-slide>
                    <swiper-slide>
                      <img
                        @mouseenter="on_bot_enter"
                        @mouseleave="on_bot_leave"
                        style="width: 4.88rem; height: 4.88rem"
                        referrerpolicy="no-referrer"
                        src="https://t7.baidu.com/it/u=4198287529,2774471735&fm=193&f=GIF"
                      />
                    </swiper-slide>
                    <div class="swiper-pagination" slot="pagination"></div>
                  </swiper>
                </div>
              </div>
            </div>
          </div>
          <div class="main3 flex-row">
            <div class="ImageText1 flex-col justify-between">
              <img
                class="pic-2"
                referrerpolicy="no-referrer"
                src="http://dftk-hw-cdn-ali.yingxiong.com/web/h_tank/assets/PC-e-slices/t-en.png"
              />
              <div class="TextGroup2 flex-col">
                <span class="paragraph1"
                  >Select your tank, armored vehicle or helicopter.Experience
                  fast pace modern warfare!
                </span>
              </div>
            </div>
          </div>
          <div class="box6 flex-row"><div class="bd1 flex-col"></div></div>
          <div class="box7 flex-row">
            <div class="block1">
              <span class="infoBox3">-Authentic Vehicles<br /></span>
              <div class="paragraph2">
                Kingtiger, Panther, T-72, T-90, Leopard II, Chieftain, AH-64, M2
                Bradley, AH-1, UH-60 Black Hawk, multiple historical famous
                vehicle await your command!<br /><br />
              </div>
              <span class="infoBox4">-Combat Modes<br /></span>
              <div class="paragraph3">
                Single Combat, Team Battle and Campaign Mode, every mode has its
                own unique gameplay and objective. But nevertheless, destroy all
                enemy will always be the surest way to win!<br />
              </div>
              <span class="paragraph4"><br /></span>
              <span class="paragraph5">-Various Tactics<br /></span>
              <div class="paragraph6">
                Every vehicle has multiple parts which could be ungraded.
                Increasing the fire power of your tank, increasing the
                maneuverability of your armoured vehicle and performance of your
                helicopter, get into a fast pace multi-arms combat!<br /><br />
              </div>
              <span class="paragraph7">-International Teams<br /></span>
              <div class="paragraph8">
                Fight with your friend against players from every corner of the
                world, Hold your position and then attack.<br /><br />
                We don`t have DEFEAT in our dictionary!
              </div>
            </div>
          </div>
          <div class="privacy">
            <router-link :to="privacyPolicyLink.to">{{ privacyPolicyLink.text }}</router-link>
            <router-link :to="termsOfServiceLink.to">{{ termsOfServiceLink.text }}</router-link>
          </div>
        </div>
      </div>
    </div>
    <div v-show="is_show" style="width:100%;height:100vh;z-index:999;background:#18120d;    position: fixed;
    top: 0;
    opacity: .5;"></div>
    <giftpackageEn/>
  </div>
  <router-view></router-view>
</div>
</template>
<script>
// 引入插件
import { swiper, swiperSlide } from "vue-awesome-swiper";
import { privacyPolicyLink, termsOfServiceLink } from '@/router/routerConfig';
import giftpackageEn from "@/components/giftpackageEn.vue";
import "swiper/dist/css/swiper.css";
export default {
  data() {
    return {
       src_video:'http://dftk.ks3-cn-beijing.ksyun.com/web_resources/004.mp4',
      video_data:[
        {
          id:1,
          src:'http://dftk-hw-cdn-ali.yingxiong.com/web/h_tank/assets/PC-img/en/002.jpg',
          text:'Clash of Panzer Official CG',
          time:'06/11 2022',
          is_show:false
        },
        {
          id:2,
          src:'http://dftk-hw-cdn-ali.yingxiong.com/web/h_tank/assets/PC-img/en/003.jpg',
          text:'Media Commercials',
          time:'05/22 2022',
          is_show:false
        },
        {
          id:3,
          src:'http://dftk-hw-cdn-ali.yingxiong.com/web/h_tank/assets/PC-img/en/005.jpg',
          text:'Tank Nightmare - AH-64C',
          time:'05/16 2022',
          is_show:false
        },
        {
          id:4,
          src:'http://dftk-hw-cdn-ali.yingxiong.com/web/h_tank/assets/PC-img/en/006.jpg',
          text:'King of Performance - ZBD-04',
          time:'03/25 2022',
          is_show:false
        },
        {
          id:5,
          src:'http://dftk-hw-cdn-ali.yingxiong.com/web/h_tank/assets/PC-img/en/007.jpg',
          text:'U.S.S.R. Series Warrior - T90',
          time:'03/19 2022',
          is_show:false
        },
        {
          id:6,
          src:'http://dftk-hw-cdn-ali.yingxiong.com/web/h_tank/assets/PC-img/en/008.jpg',
          text:'Historical Legend - T34',
          time:'02/20 2022',
          is_show:false
        },
      ],
      close:false,
      is_loop:false,
      is_show:false,
      is_code: false,
      active: true,
      nice: false,
      word1: true,
      word1_1: false,
      word2: false,
      word2_2: true,
      section7: true,
      section7_0: false,
      section7_1: false,
      section7_2: true,
      selection: "English",
      lan: ["繁體中文", "English", "Русский"],
      drop_down: false,
      btnplay: true, //默认播放
      constants: {},
      swiperOption: {
        loop: true,
        autoplay: {
          delay: 3000,
          stopOnLastSlide: false,
          disableOnInteraction: false,
        },
        // 显示分页
        pagination: {
          el: ".swiper-pagination",
          clickable: true, //允许分页点击跳转
          bulletClass: "my-bullet",
          bulletActiveClass: "my-bullet-active",
        },
        observer: true, //修改swiper自己或子元素时，自动初始化swiper
        observeParents: true, //修改swiper的父元素时，自动初始化swiper
        // 设置点击箭头
        navigation: {
          nextEl: ".swiper-button-next",
          prevEl: ".swiper-button-prev",
        },
      },
      swiperOption1: {
        loop: true,
        autoplay: {
          delay: 3000,
          stopOnLastSlide: false,
          disableOnInteraction: false,
        },
        // 显示分页
        pagination: {
          el: ".swiper-pagination",
          clickable: true, //允许分页点击跳转
          bulletClass: "my-bullet",
          bulletActiveClass: "my-bullet-active",
        },
        observer: true, //修改swiper自己或子元素时，自动初始化swiper
        observeParents: true, //修改swiper的父元素时，自动初始化swiper
        // 设置点击箭头
        navigation: {
          nextEl: ".swiper-button-next",
          prevEl: ".swiper-button-prev",
        },
      },
      swiper: null,
      swiper1: null,
      privacyPolicyLink,
      termsOfServiceLink,
    };
  },

  components: {
    swiper,
    swiperSlide,
    giftpackageEn,
  },
  computed: {},
  watch: {
    $route: {
      immediate: true,
      handler(to, from) {
        console.log('path:',this.$route.path)
        if (to.path == "/en") {
          const meta = document.createElement("meta");
          window.document.title = to.meta.title;
        } else {
          document.title = "";
        }
      },
    },
  },
  mounted() {
    window.setTimeout(()=>{this.is_loop=true},1000)
    window.addEventListener("click", this.all);
    this.$nextTick(() => {
        if (this.$refs.mySwiper && this.$refs.mySwiper.swiper) {
            this.swiper = this.$refs.mySwiper.swiper;
            this.swiper.slideTo(3, 1000, false);
        }

        if (this.$refs.mySwiper1 && this.$refs.mySwiper1.swiper) {
            this.swiper1 = this.$refs.mySwiper1.swiper;
            this.swiper1.slideTo(3, 1000, false);
        }
    });
    
  },
  methods: {
    //根据id播放视频
    play_video(id){
      this.close=true;
      this.is_show=true;
      if(id==1){
        this.src_video='https://cdnalitank.oss-cn-hongkong.aliyuncs.com/video/en/001.mp4'
      }
      if(id==2){
        this.src_video='https://cdnalitank.oss-cn-hongkong.aliyuncs.com/video/en/002.mp4'
      }
      if(id==3){
        this.src_video='https://cdnalitank.oss-cn-hongkong.aliyuncs.com/video/en/003.mp4'
      }
      if(id==4){
        this.src_video='https://cdnalitank.oss-cn-hongkong.aliyuncs.com/video/en/004.mp4'
      }
      if(id==5){
        this.src_video='https://cdnalitank.oss-cn-hongkong.aliyuncs.com/video/en/005.mp4'
      }
      if(id==6){
        this.src_video='https://cdnalitank.oss-cn-hongkong.aliyuncs.com/video/en/006.mp4'
      }
    },
     c_close(){
      this.close=false;
      this.is_show=false
    },
    input_out(index){
      this.video_data[index].is_show=false
    },
    input_in(index){
      this.video_data[index].is_show=true
    },
    //打开头部视频
    open(){
      this.close=true;
      this.is_show=true;
      this.src_video='https://cdnalitank.oss-cn-hongkong.aliyuncs.com/video/en/0.mp4'
    },
    enter_code() {
      this.is_code = true;
    },
    leave_code() {
      this.is_code = false;
    },
    phone() {
      window.open("https://apps.apple.com/app/clash-of-panzer/id1477795249");
    },
    google() {
      window.open(
        "https://play.google.com/store/apps/details?id=com.tank.play4fun"
      );
    },
    recharge() {
      window.open(
        "https://webshop-clash-of-panzer.xsolla.site/"
      );
    },
    pcDown() {
      window.open(
        "https://webcdn.wanyuhudong.com/ovtank/client/pc/HWDFTK.exe"
      );
    },
    new_active() {
      if (this.word1 == false) {
        this.swiper = this.$refs.mySwiper.swiper;
        this.word1 = true;
        this.word1_1 = false;

        this.word2 = false;
        this.word2_2 = true;

        this.active = true;
        this.nice = false;
        this.swiper.slideTo(3, 1000, false);
      }
    },
    new_nice() {
      if (this.word2 == false) {
        this.swiper1 = this.$refs.mySwiper1.swiper;

        this.word2 = true;
        this.word2_2 = false;

        this.word1 = false;
        this.word1_1 = true;

        this.nice = true;
        this.active = false;
        this.swiper1.slideTo(3, 1000, false);
      }
    },
    facebook() {
      window.open("https://www.facebook.com/clashofpanzer/");
    },
    youtube() {
      window.open("https://www.youtube.com/channel/UCKi2cS_f8nEx7eJs32AxYkw");
    },
    instagram() {
      window.open("https://www.instagram.com/clashofpanzer_official/");
    },
    query_value(e) {
      if (this.selection != e.target.innerText) {
        if (e.target.innerText == "简体中文") {
          this.$router.push("/chs");
        }
        if (e.target.innerText == "繁體中文") {
          this.$router.push("/cht");
        }
        if (e.target.innerText == "Русский") {
          this.$router.push("/rus");
        }
      }
    },
    pri_po() {
      this.$router.push("/en/privacy_en");
    },
    pri_ser() {
      this.$router.push("/en/per_sdk_en");
    },
    all() {
      this.drop_down = false;
    },
    select_lan() {
      this.drop_down = !this.drop_down;
    },
    stop() {
      //通过调用鼠标移入移除间接实现暂停播放
      this.btnplay = !this.btnplay;
      this.btnplay ? this.on_bot_leave() : this.on_bot_enter();
    },
    on_bot_enter() {
      if(this.swiper && this.swiper.autoplay)
      this.swiper.autoplay.stop();
    },
    on_bot_leave() {
      if(this.swiper && this.swiper.autoplay)
      this.swiper.autoplay.start();
    },
  },
};
</script>
<style lang='scss' scoped>
.video_play{
  // animation: vGo 2s linear infinite;
  width: .59rem;
  height: .59rem;
  position: absolute;
  top: 40%;
  left: 50%;
  transform: translate(-50%, -50%);
  cursor: pointer;
}
.box_1_1{
  width: 13.026rem;
  margin-left: 3.8rem;
  // margin-top: .66rem;
  flex-direction: row;
  display: inline-block;
}
.audition_ph{
  width: 100%;
 height: 2.133rem;
 display: block;
  
}
.audition_d{
 position: relative;
 width: 3.8rem;
 height: 2.75rem;
 display: inline-block;
 margin-right: 0.18rem;
 background: #272A30;
 margin-top: 0.3rem;
  div{
    font-size: .19rem;
    /* margin: 0; */
    color: #fff;
    // line-height: .59rem;
    padding-top: .2rem;
    margin-left: 0.21rem;
    .audition_ph_m{
      width: 2.14rem;
      overflow: hidden;
      text-overflow: ellipsis;
      display: inline-block;
      white-space:nowrap;
    }
    .audition_ph_t{
      margin-left: .47rem;
      color: #999999;
      display: inline-block;
      vertical-align: top;
      margin-left: .43rem;
    }
  }
}
.box_1{
  align-items: center;
  justify-content: center;
  flex-direction: column;
  margin-top: .66rem;
}
.audition{
  width: 4.48rem;
  height: .34rem;
}
.pc-down-box-en{
  position: absolute;
  left: 50%;
  bottom: 1.2rem;
  transform: translate(-50%, 0);
}
.pc-down-img-en{
  width: auto;
  height: .85rem;
  cursor: pointer;
}
.img3-box {
  position: absolute;
  width: 100%;
  display: flex;
  justify-content: center;
  bottom: 0.28rem;
}
.img3-1 {
  width: 2.33rem;
  height: 0.65rem;
  margin-left: 0.15rem;
  cursor: pointer;
}
.label1-2-4 {
  position: absolute;
  left: 13rem;
  top: 0.73rem;
  width: 1.94rem;
  height: 2.07rem;
  z-index: 99;
}
.label1-2-3 {
  width: 0.5rem;
  height: 0.5rem;
  margin-right: 0.12rem;
  margin-top: -0.09rem;
  cursor: pointer;
  z-index: 99;
}
.s-load {
  font-size: 0.16rem;
  font-family: Microsoft YaHei;
  font-weight: bold;
  color: #201e1e;
  line-height: 0.3rem;
  margin-left: 0.07rem;
  height: 0.2rem;
  z-index: 99;
}
.lanel-i {
  height: 0.24rem;
  // margin-left: 12.23rem;
  border: 1px solid #201e13;
  margin-left: 0.4rem;
  margin-top: 0.04rem;
  z-index: 99;
}
.word-2_2 {
  //   width: 1.04rem;
  height: 0.26rem;
  overflow-wrap: break-word;
  color: rgba(233, 147, 47, 1);
  font-size: 0.26rem;
  font-family: MicrosoftYaHei-Bold;
  text-align: left;
  white-space: nowrap;
  line-height: 0.26rem;
  margin-left: 0.19rem;
  display: block;
  cursor: pointer;
}
.word1-1_1 {
  color: rgb(153, 153, 153);
  width: 1.03rem;
  height: 0.26rem;
  font-size: 0.26rem;
  overflow-wrap: break-word;
  // color: rgba(233, 147, 47, 1);
  font-size: 0.26rem;
  font-family: MicrosoftYaHei-Bold;
  text-align: left;
  white-space: nowrap;
  line-height: 0.26rem;
  display: block;
  cursor: pointer;
}
.section7-1 {
  background-color: rgba(233, 147, 47, 1);
  height: 0.44rem;
  margin-top: 0.04rem;
  //   color: rgb(153, 153, 153);
  color: rgb(255, 255, 255);
  width: 2.34rem;
  cursor: pointer;
}
.section7-2 {
  background-color: none;
  height: 0.44rem;
  margin-top: 0.04rem;
  color: rgb(153, 153, 153);
  //   color: rgb(255, 255, 255);
  width: 2.34rem;
  cursor: pointer;
}
.section7 {
  background-color: rgba(233, 147, 47, 1);
  height: 0.44rem;
  color: rgba(255, 255, 255, 1);
  margin-top: 0.82rem;
  width: 2.34rem;
  cursor: pointer;
}
.section7-0 {
  background-color: none;
  height: 0.44rem;
  color: rgb(153, 153, 153);
  margin-top: 0.82rem;
  width: 2.34rem;
  cursor: pointer;
}
.code-title-e {
  font-size: 0.14rem;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #999999;
  line-height: 0.17rem;
  margin: 0, 0, 0, 0.02rem;
  margin: 0;
  margin-left: 0.2rem;
  text-align: center;
  width: 1.93rem;
  /* height: 223px; */
  background: #202020;
  /* border: 4px solid #202020; */
  /* border-right: 0; */
  padding-top: 0.03rem;
  padding-bottom: 0.03rem;
}
.block3 {
  width: 1.14rem;
  height: 0.5rem;
  margin: -0.27rem 0 0 1.6rem;
}

.img6 {
  width: 0.5rem;
  height: 0.5rem;
}

.block8 {
  width: 2.34rem;
  height: 5.49rem;
  margin: 0.4rem 0 0 0.08rem;
}

.pic1 {
  width: 1.93rem;
  height: 2.23rem;
  margin-left: 0.2rem;
}

.img4 {
  width: 1.92rem;
  height: 0.58rem;
  margin: 0.18rem 0 0 0.2rem;
  cursor: pointer;
}

.pic2 {
  width: 1.92rem;
  height: 0.58rem;
  margin: 0.12rem 0 0 0.2rem;
  cursor: pointer;
}

.img5 {
  width: 1.92rem;
  height: 0.58rem;
  margin: 0.11rem 0 0 0.2rem;
  cursor: pointer;
}

.info2-2 {
  width: 0.76rem;
  height: 0.14rem;
  overflow-wrap: break-word;
  //   color: rgba(255, 255, 255, 1);
  font-size: 0.16rem;
  font-family: MicrosoftYaHei-Bold;
  text-align: center;
  white-space: nowrap;
  line-height: 0.16rem;
  display: block;
  margin: 0.15rem 0 0 0.79rem;
}

.word-1 {
  width: 0.68rem;
  height: 0.14rem;
  overflow-wrap: break-word;
  //   color: rgba(153, 153, 153, 1);
  font-size: 0.16rem;
  font-family: MicrosoftYaHei;
  text-align: center;
  white-space: nowrap;
  line-height: 0.16rem;
  display: block;
  margin: 0.15rem 0 0 0.82rem;
}

.option:hover {
  color: #e9932f;
  cursor: pointer;
}
.select-box {
  border: none;
  background: none;
  color: #201e1e;
  width: 0.76rem;
  padding: 0;
  cursor: pointer;
  outline: none;
  font-size: 0.16rem;
}
::v-deep .my-bullet {
  z-index: 99999999999;
  width: 0.1rem !important;
  height: 0.1rem !important;
  // display: inline-block;
  border-radius: 50% !important;
  // background: red!important;
  background: url(http://dftk-hw-cdn-ali.yingxiong.com/web/h_tank/assets/PC-c-slices/White-dot.png);
  background-size: 100% 100%;
  margin: 0 auto;
  text-align: center;
  display: inline-block;
  &:nth-child(2) {
    margin: 0 0.1rem !important;
  }
}
::v-deep .my-bullet-active {
  // background: #FD882E!important;
  background: url(http://dftk-hw-cdn-ali.yingxiong.com/web/h_tank/assets/PC-c-slices/Orange-dot.png);
  background-size: 100% 100%;
}

.swiper-container {
  // position: relative;
  width: 4.88rem !important;
  height: 4.88rem !important;
  // background: pink;
}
.swiper-container .swiper-slide {
  width: 4.88rem !important;
  height: 4.88rem !important;
  line-height: 200px;
  // background: yellowgreen;
  // color: #000;
  // font-size: 16px;
  // text-align: center;
}

.i-footer {
  width: 100%;
  height: 1.6rem;
  background: #1b1b1b;
  clear: both;
  .i-fotcon {
    display: flex;
    align-items: center;
    justify-content: center;
    height: 1.4rem;
    margin: 0 auto;
    overflow: hidden;
    text-align: center;
    .i-fot-logo {
      // width: 5.00rem;
      height: 1rem;
      margin-top: 0.26rem;
      float: left;
      border-right: 1px solid #666666;
      display: block;
      overflow: hidden;
      img {
        display: block;
        float: right;
        width: 2.58rem;
        height: 1rem;
        margin: 0.08rem 0.25rem 0 0;
      }
    }
    .i-fot-text {
      float: left;
      display: block;
      margin-top: 0.22rem;
      padding-left: 0.25rem;
      p {
        font-size: 0.1rem;
        line-height: 0.22rem;
        color: #c5c5c5;
        text-align: left;
        float: left;
        margin: 0;
        a.i-fot-border-left {
          border-left: 1px solid #484747;
          padding-left: 0.05rem;
        }
        a {
          display: inline-block;
          /* width: 15px; */
          /* height: 15px; */
          /* vertical-align: middle; */
          margin: 0 0.03rem;
          color: #c5c5c5;
        }
      }
    }
  }
  img {
    overflow: hidden;
    vertical-align: top;
  }
}

.page {
  position: relative;
  // width: 19.20rem;
  // height: 25.41rem;
  // overflow-x: hidden;
  margin: 0 auto;
}

.group1 {
  // height: 25.41rem;
  // width: 19.2rem;
  // min-width: 1280px;
  // width:19.20rem;
  background: url(http://dftk-hw-cdn-ali.yingxiong.com/web/h_tank/assets/PC-e-slices/bg.jpg) no-repeat;
  background-size: 100% 100%;
}

.main1 {
  // width: 1920px;
  // height: 25.38rem;
}

.box8 {
  height: 7.79rem;
  background: url(http://dftk-hw-cdn-ali.yingxiong.com/web/h_tank/assets/PC-c-slices/title.png) no-repeat;
  position: relative;
  background-size: 100% 100%;
  // width: 19.2rem;
  // min-width: 1280px;
  // width:19.20rem
}

.main2 {
  // width: 1858px;
  height: 1.13rem;
  margin: 0.24rem 0 0 0.4rem;
}

.img1 {
  width: 3.03rem;
  height: 0.99rem;
  z-index: 99;
}

.label1 {
  width: 0.24rem;
  height: 0.24rem;
  margin-left: 9.9rem;
  margin-top: 0.04rem;
  z-index: 99;
}
.label1-2 {
  width: 0.24rem;
  height: 0.24rem;
  margin-left: 0.4rem;
  margin-top: 0.04rem;
  z-index: 99;
}

.infoBox1 {
  width: 0.66rem;
  height: 0;
  overflow-wrap: break-word;
  color: #201e1e;
  font-size: 0.16rem;
  font-family: MicrosoftYaHei-Bold;
  text-align: left;
  line-height: 0.3rem;
  white-space: nowrap;
  display: block;
  margin: 0rem 0 0 0.11rem;
  z-index: 100000;
}

.icon1 {
  width: 0.15rem;
  height: 0.09rem;
  margin: 0.08rem 0 0 0rem;
  cursor: pointer;
}

.bd2 {
  width: 6.75rem;
  height: 2.74rem;
  margin: -1.1rem 0 2.61rem 6.75rem;
}

.img3 {
  width: 5.84rem;
  height: 2.35rem;
}

.box9 {
  // width: 1920px;
  // height: 16.09rem;
}

.box1 {
  width: 2.7rem;
  height: 0.26rem;
  margin: 0.68rem 0 0 3.7rem;
}

.word1_1 {
  width: 1.03rem;
  height: 0.26rem;
  overflow-wrap: break-word;
  color: rgba(233, 147, 47, 1);
  font-size: 0.26rem;
  font-family: MicrosoftYaHei-Bold;
  text-align: left;
  white-space: nowrap;
  line-height: 0.26rem;
  display: block;
}

.group4 {
  width: 1px;
  height: 0.24rem;
  // background: url(https://lanhu.oss-cn-beijing.aliyuncs.com/psge81kpqrh8wycszorbtf5s0iv1lep5ab0cc4d08a-e81c-4206-95c3-e04c37873410) -1px -1px
  //   no-repeat;
  border-left: 1px solid #323a44;
  margin: 1px 0 0 20px;
}

.info1 {
  //   width: 1.04rem;
  width: 0.76rem;
  height: 0.14rem;
  overflow-wrap: break-word;
  //   color: rgba(255, 255, 255, 1);
  font-size: 0.16rem;
  font-family: MicrosoftYaHei-Bold;
  text-align: center;
  white-space: nowrap;
  line-height: 0.16rem;
  display: block;
  margin: 0.15rem 0 0 0.79rem;
}
.info1-2_2 {
  //   width: 1.04rem;
  height: 0.26rem;
  overflow-wrap: break-word;
  color: rgba(153, 153, 153, 1);
  font-size: 0.26rem;
  font-family: MicrosoftYaHei-Bold;
  text-align: left;
  white-space: nowrap;
  line-height: 0.26rem;
  margin-left: 0.19rem;
  display: block;
  cursor: pointer;
}

.group5 {
  // background-color: rgba(50, 58, 68, 1);
  width: 0.08rem;
  height: 0.14rem;
  margin: 0.05rem 0 0 0.15rem;
  width: 0;
  height: 0;
  border: 0.08rem solid transparent;
  /* border-top: none; */
  border-left-color: rgb(50, 58, 68);
}

.box2 {
  // width: 1560px;
  height: 5.26rem;
  margin: 0.05rem 0 0 3.6rem;
}

.mod1 {
  width: 12.03rem;
  height: 5.26rem;
}

.pic0 {
  width: 12.03rem;
  height: 0.08rem;
}

.box3 {
  width: 11.81rem;
  height: 4.88rem;
  margin-top: 0.3rem;
}

.outer1 {
  height: 4.88rem;
  // background: url(http://dftk-hw-cdn-ali.yingxiong.com/web/h_tank/assets/PC-c-slices/activity.png) 100% no-repeat;
  background-size: 100% 100%;
  width: 4.88rem;
}

.outer2 {
  width: 0.95rem;
  height: 0.15rem;
  margin: 4.64rem 0 0 1.97rem;
}

.icon2 {
  width: 0.15rem;
  height: 0.15rem;
}

.icon3 {
  width: 0.15rem;
  height: 0.15rem;
}

.icon4 {
  width: 0.15rem;
  height: 0.15rem;
}

.label2 {
  width: 0.15rem;
  height: 0.15rem;
}

.label3 {
  width: 0.15rem;
  height: 0.15rem;
}

.outer3 {
  width: 6.73rem;
  height: 4.64rem;
}

.word2 {
  width: 0.76rem;
  overflow-wrap: break-word;
  color: rgba(153, 153, 153, 1);
  font-size: 0.14rem;
  font-family: MicrosoftYaHei;
  text-align: left;
  white-space: nowrap;
  line-height: 0.14rem;
  margin-left: 1px;
  display: block;
}

.word3 {
  width: 3.82rem;
  height: 0.22rem;
  overflow-wrap: break-word;
  color: rgba(211, 211, 211, 1);
  font-size: 0.22rem;
  font-family: MicrosoftYaHei-Bold;
  text-align: left;
  white-space: nowrap;
  line-height: 0.22rem;
  margin-top: 0.12rem;
  display: block;
}

.infoBox2 {
  width: 6.95rem;
  height: 3.99rem;
  overflow-wrap: break-word;
  color: rgba(153, 153, 153, 1);
  font-size: 0.14rem;
  font-family: MicrosoftYaHei;
  text-align: justifyLeft;
  line-height: 0.24rem;
  // white-space: nowrap;
  display: block;
  margin: 0.2rem 0 0 0.04rem;
  overflow: auto;
  padding-right: 0.1rem;

  scrollbar-color: #e9932f #37424d; /* 第一个方块颜色，第二个轨道颜色(用于更改火狐浏览器样式) */
  scrollbar-width: thin; /* 火狐滚动条无法自定义宽度，只能通过此属性使滚动条宽度变细 */
  -ms-overflow-style: none; /* 隐藏滚动条（在IE和Edge两个浏览器中很难更改样式，固采取隐藏方式） */

  /* 以下是chrome浏览器自定义滚动条样式方式 */
  &::-webkit-scrollbar {
    /*滚动条整体样式*/
    width: 0.03rem; /*高宽分别对应横竖滚动条的尺寸*/
    height: 1px;
  }
  &::-webkit-scrollbar-thumb {
    /*滚动条里面小方块*/
    border-radius: 0.03rem;
    -webkit-box-shadow: inset 0 0 1px rgba(0, 0, 0, 0);
    background: #e9932f;
  }
  &::-webkit-scrollbar-track {
    /*滚动条里面轨道*/
    -webkit-box-shadow: inset 0 0 1px rgba(0, 0, 0, 0);
    border-radius: 3px;
    background: #37424d;
  }
}

// .mod2 {
//   height: 2.22rem;
//   background: url(http://dftk-hw-cdn-ali.yingxiong.com/web/h_tank/assets/PC-c-slices/Download-box.png) 0px 0px no-repeat;
//   background-size: 100% 100%;
//   margin-top: .07rem;
//   width: 2.42rem;
// }

// .outer4 {
//   width: 2.34rem;
//   height: 1.67rem;
//   margin: .42rem 0 0 .08rem;
// }

.outer4 {
  height: 6.51rem;
  background: url(http://dftk-hw-cdn-ali.yingxiong.com/web/h_tank/assets/PC-e-slices/box.png) 0px 0px no-repeat;
  background-size: 100% 100%;
  margin-left: 0.98rem;
  width: 2.42rem;
  position: fixed;
  top: 50%;
  right: 0;
  transform: translate(0, -40%);
}
.pic3 {
  width: 0.5rem;
  height: 0.5rem;
}

.group6 {
  height: 0.54rem;
  background: url(http://dftk-hw-cdn-ali.yingxiong.com/web/h_tank/assets/PC-c-slices/Black-box.png) -0.04rem -0.04rem
    no-repeat;
  background-size: 100% 100%;
  width: 1.88rem;
  // border: 2px solid #6F6F6F;
  margin: -0.02rem 0 0 0.22rem;
  cursor: pointer;
}

.section1 {
  height: 0.43rem;
  // background: url(https://lanhu.oss-cn-beijing.aliyuncs.com/psxp5xb13coefnoe71v5jf8rkuede0bmurcf313910-ba13-4fd6-896c-299994b1bbe1)
  // 100% no-repeat;
  width: 1.57rem;
  // margin: 5px 0 0 16px;
  align-items: center;
  justify-content: end;
}

.layer1 {
  width: 1.23rem;
  height: 0.28rem;
  // margin: 9px 0 0 3px;
}

.icon5 {
  width: 0.34rem;
  height: 0.28rem;
}

.TextGroup1 {
  height: 0.17rem;
  margin-top: 0.05rem;
  width: 0.79rem;
}

.word4 {
  width: 0.79rem;
  height: 0.17rem;
  overflow-wrap: break-word;
  color: rgba(255, 255, 255, 1);
  font-size: 0.16rem;
  font-family: MicrosoftYaHei-Bold;
  text-align: left;
  white-space: nowrap;
  line-height: 0.16rem;
  display: block;
}

.group7 {
  background-color: rgba(233, 147, 47, 1);
  height: 0.44rem;
  margin-top: 0.4rem;
  width: 2.34rem;
  cursor: pointer;
}

.word5 {
  width: 0.64rem;
  height: 0.16rem;
  overflow-wrap: break-word;
  color: rgba(255, 255, 255, 1);
  font-size: 0.16rem;
  font-family: MicrosoftYaHei-Bold;
  text-align: center;
  white-space: nowrap;
  line-height: 0.16rem;
  display: block;
  margin: 0.14rem 0 0 0.84rem;
}

.info2 {
  width: 0.64rem;
  height: 0.16rem;
  overflow-wrap: break-word;
  color: rgba(153, 153, 153, 1);
  font-size: 0.16rem;
  font-family: MicrosoftYaHei;
  text-align: center;
  white-space: nowrap;
  line-height: 0.16rem;
  display: block;
  margin: 0.15rem 0 0 0.84rem;
}

.main3 {
  width: 4.68rem;
  //   height: .89rem;
  margin: 1.67rem 0 0 10.95rem;
}

.ImageText1 {
  width: 4.68rem;
  //   height: .89rem;
}

.pic-2 {
  width: 1.68rem;
  height: 0.31rem;
}

.TextGroup2 {
  //   height: .44rem;
  margin-top: 0.14rem;
  width: 4.68rem;
}

.paragraph1 {
  width: 4.68rem;
  //   height: .44rem;
  overflow-wrap: break-word;
  color: rgba(255, 255, 255, 1);
  font-size: 0.18rem;
  font-family: MicrosoftYaHei-Bold;
  text-align: left;
  line-height: 0.26rem;
  //   white-space: nowrap;
  display: block;
}

.box6 {
  width: 0.39rem;
  height: 0.04rem;
  margin: 0.3rem 0 0 10.97rem;
}

.bd1 {
  background-color: rgba(233, 147, 47, 1);
  width: 0.39rem;
  height: 0.04rem;
}

.box7 {
  width: 4.65rem;
  height: 4.23rem;
  margin: 0.2rem 0 2.51rem 10.95rem;
}

.block1 {
  width: 4.65rem;
  height: 4.23rem;
  overflow-wrap: break-word;
  font-size: 0;
  font-family: MicrosoftYaHei;
  text-align: justifyLeft;
  // line-height: 24px;
  // white-space: nowrap;
}

.infoBox3 {
  // width: 465px;
  // height: 423px;
  overflow-wrap: break-word;
  color: rgba(255, 255, 255, 1);
  font-size: 0.14rem;
  font-family: MicrosoftYaHei;
  text-align: left;
  line-height: 0.24rem;
  // white-space: nowrap;
}

.paragraph2 {
  // width: 465px;
  // height: 423px;
  overflow-wrap: break-word;
  color: rgba(153, 153, 153, 1);
  font-size: 0.14rem;
  font-family: MicrosoftYaHei;
  text-align: left;
  line-height: 0.24rem;
  // white-space: nowrap;
}

.infoBox4 {
  // width: 465px;
  // height: 423px;
  overflow-wrap: break-word;
  color: rgba(255, 255, 255, 1);
  font-size: 14px;
  font-family: MicrosoftYaHei;
  text-align: left;
  line-height: 0.24rem;
  // white-space: nowrap;
}

.paragraph3 {
  // width: 465px;
  // height: 423px;
  overflow-wrap: break-word;
  color: rgba(153, 153, 153, 1);
  font-size: 0.14rem;
  font-family: MicrosoftYaHei;
  text-align: left;
  line-height: 0.24rem;
  // white-space: nowrap;
}

.paragraph4 {
  // width: 465px;
  // height: 423px;
  overflow-wrap: break-word;
  color: rgba(153, 153, 153, 1);
  font-size: 0.14rem;
  font-family: MicrosoftYaHei;
  text-align: left;
  line-height: 0.24rem;
  // white-space: nowrap;
}

.paragraph5 {
  // width: 465px;
  // height: 423px;
  overflow-wrap: break-word;
  color: rgba(255, 255, 255, 1);
  font-size: 14px;
  font-family: MicrosoftYaHei;
  text-align: left;
  line-height: 0.24rem;
  // white-space: nowrap;
}

.paragraph6 {
  // width: 465px;
  // height: 423px;
  overflow-wrap: break-word;
  color: rgba(153, 153, 153, 1);
  font-size: 0.14rem;
  font-family: MicrosoftYaHei;
  text-align: left;
  line-height: 0.24rem;
  // white-space: nowrap;
}

.paragraph7 {
  // width: 465px;
  // height: 423px;
  overflow-wrap: break-word;
  color: rgba(255, 255, 255, 1);
  font-size: 0.14rem;
  font-family: MicrosoftYaHei;
  text-align: left;
  line-height: 0.24rem;
  // white-space: nowrap;
}

.paragraph8 {
  // width: 465px;
  // height: 423px;
  overflow-wrap: break-word;
  color: rgba(153, 153, 153, 1);
  font-size: 0.14rem;
  font-family: MicrosoftYaHei;
  text-align: left;
  line-height: 0.24rem;
  // white-space: nowrap;
}

// .group8 {
//   height: 1.50rem;
//   background: url(https://lanhu.oss-cn-beijing.aliyuncs.com/psnaks7qkfgfe821tr6pzgmx3r5l9sqxfc2e4f749-d12a-4f53-a382-53eb5d614629) -311px
//     0px no-repeat;
//   margin-top: -1px;
//   width: 1920px;
// }

.img2 {
  width: 2.58rem;
  height: 1rem;
  margin: 0.25rem 0 0 4.68rem;
}
.privacy {
  font-size: 14px;
  margin: 0.2rem 0 0.8rem 13.55rem;
  a{
    color: #ee9220;
    margin-left: 0.2rem;
  }
}
</style>

